export default function CTASection() {
  return (
    <section className="relative mx-4 md:mx-6 my-10 md:my-14 rounded-2xl md:rounded-3xl overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20inviting%20lifestyle%20scene%20with%20curated%20fashion%20items%20artfully%20arranged%20on%20light%20cream%20linen%20surface%20soft%20natural%20daylight%20streaming%20from%20window%20gentle%20shadows%20olive%20green%20and%20terracotta%20accents%20editorial%20photography%20european%20style%20sophisticated%20calm%20atmosphere%20organic%20textures&width=1600&height=600&seq=cta-main-2026&orientation=landscape"
        alt="Itaobuy Spreadsheet acquista ora"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 px-8 md:px-16 py-16 md:py-24 flex flex-col md:flex-row items-center justify-between gap-8">
        <div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white max-w-lg leading-tight">
            Pronto a scoprire prodotti migliori?
          </h2>
          <p className="text-white/80 text-base mt-3 max-w-md">
            Accedi subito a Itaobuy Sheet e inizia a esplorare tutte le categorie disponibili.
          </p>
        </div>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-foreground-900 text-base font-semibold hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span>Buy It Now</span>
          <span className="w-8 h-8 rounded-full bg-foreground-900 flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-sm"></i>
          </span>
        </a>
      </div>
    </section>
  );
}